/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutocompleteAddressResponseAddressesInner
 */
export interface AutocompleteAddressResponseAddressesInner {
    /**
     * 
     * @type {string}
     * @memberof AutocompleteAddressResponseAddressesInner
     */
    formattedAddress: string;
    /**
     * 
     * @type {string}
     * @memberof AutocompleteAddressResponseAddressesInner
     */
    placeId: string;
}

/**
 * Check if a given object implements the AutocompleteAddressResponseAddressesInner interface.
 */
export function instanceOfAutocompleteAddressResponseAddressesInner(value: object): value is AutocompleteAddressResponseAddressesInner {
    if (!('formattedAddress' in value) || value['formattedAddress'] === undefined) return false;
    if (!('placeId' in value) || value['placeId'] === undefined) return false;
    return true;
}

export function AutocompleteAddressResponseAddressesInnerFromJSON(json: any): AutocompleteAddressResponseAddressesInner {
    return AutocompleteAddressResponseAddressesInnerFromJSONTyped(json, false);
}

export function AutocompleteAddressResponseAddressesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutocompleteAddressResponseAddressesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'formattedAddress': json['formattedAddress'],
        'placeId': json['placeId'],
    };
}

export function AutocompleteAddressResponseAddressesInnerToJSON(json: any): AutocompleteAddressResponseAddressesInner {
    return AutocompleteAddressResponseAddressesInnerToJSONTyped(json, false);
}

export function AutocompleteAddressResponseAddressesInnerToJSONTyped(value?: AutocompleteAddressResponseAddressesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'formattedAddress': value['formattedAddress'],
        'placeId': value['placeId'],
    };
}

